// extracted by mini-css-extract-plugin
export var captionWrapper = "figure-module--captionWrapper--5401f";
export var figure = "figure-module--figure--22ca2";